import * as S from './styles';
import { useHistory } from 'react-router-dom';
import React from 'react';

export interface MenuOption {
  label: string;
  url: string;
  isExternal?: boolean;
}

interface ComboBoxProps {
  options: MenuOption[];
  placeholder?: string;
}

const ComboBox: React.FC<ComboBoxProps> = ({
  options,
  placeholder = "MAIS ACESSOS"
}) => {
  const history = useHistory();

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedUrl = event.target.value;

    if (!selectedUrl) return;

    const isExternal = selectedUrl.startsWith('http') ||
      options.find(opt => opt.url === selectedUrl)?.isExternal;

    if (isExternal) {
      const link = document.createElement('a');
      link.href = selectedUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.click();
    } else {
      history.push(selectedUrl);
    }

    event.target.value = "";
  };

  return (
    <S.MenuContainer>
      <select
        defaultValue=""
        onChange={handleSelectChange}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>

        {options.map((option, index) => (
          <option key={index} value={option.url}>
            {option.label.toUpperCase()}
          </option>
        ))}
      </select>
    </S.MenuContainer>
  );
};

export default ComboBox;